const VALID_EXTENSIONS = ['.png', '.jpg', '.jpeg', '.pdf'];

export default VALID_EXTENSIONS;
